import { toaster } from 'components/v2/toast';
import React from 'react';
import styled from 'styled-components';
import { LcaXLValidationError } from 'types/lca-results/LcaXLValidationError';
import { LcaXLValidationErrorCode } from 'types/lca-results/LcaXLValidationErrorCode';

interface Props {
  errors: LcaXLValidationError[];
  style?: React.CSSProperties;
}

const WizardLcaResultsErrors: React.FC<Props> = ({ errors, style }) => {
  if (errors.some((er) => er.code === LcaXLValidationErrorCode.INVALID_VALUE_MAX_LENGTH)) {
    return (
      <Wrapper style={style}>
        <ErrorSummary>Document is not valid</ErrorSummary>
      </Wrapper>
    );
  }

  return (
    <Wrapper style={style}>
      <ErrorSummary>Document is not valid</ErrorSummary>

      {errors.some((er) => er.indicatorCode && er.code === LcaXLValidationErrorCode.MISSING_REQUIRED_INDICATOR) && (
        <>
          <ErrorSummary style={{ marginTop: '0.5em' }}>Mandatory rows are missing.</ErrorSummary>
          {errors
            .filter((er) => er.code === LcaXLValidationErrorCode.MISSING_REQUIRED_INDICATOR)
            .map((er) => (
              <div key={er.indicatorCode}>
                <strong>{er.indicatorCode}:</strong> {er.message}
              </div>
            ))}
        </>
      )}
      {errors.some((er) => er.code === LcaXLValidationErrorCode.INVALID_MODULE_VALUE) && (
        <ErrorSummary style={{ marginTop: '0.5em' }}>Mandatory rows have invalid values.</ErrorSummary>
      )}
      {errors
        .filter((er) => er.indicatorCode && er.code === LcaXLValidationErrorCode.INVALID_MODULE_VALUE)
        .map((er) => (
          <div key={er.indicatorCode}>
            <strong>{er.indicatorCode}:</strong> {er.message}
          </div>
        ))}
      {errors.some((er) => er.code === LcaXLValidationErrorCode.INVALID_MODULE_COLUMNS) && (
        <>
          <ErrorSummary style={{ marginTop: '0.5em' }}>
            Mandatory module columns must each contain either only numeric values or only 'ND'.
          </ErrorSummary>
          {errors
            .filter((er) => er.code === LcaXLValidationErrorCode.INVALID_MODULE_COLUMNS)
            .map((er, i) => (
              <div key={i}>
                <strong>Column(s):</strong> {er.message}
              </div>
            ))}
        </>
      )}
      {errors.some((er) => er.code === LcaXLValidationErrorCode.INVALID_OPTIONAL_INDICATOR_VALUES) && (
        <ErrorSummary style={{ marginTop: '0.5em' }}>
          Optional rows cannot be empty, must have numeric values or 'ND'.
        </ErrorSummary>
      )}
      {errors
        .filter((er) => er.indicatorCode && er.code === LcaXLValidationErrorCode.INVALID_OPTIONAL_INDICATOR_VALUES)
        .map((er) => (
          <div key={er.indicatorCode}>
            <strong>{er.indicatorCode}:</strong> {er.message}
          </div>
        ))}
    </Wrapper>
  );
};

export default WizardLcaResultsErrors;

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.colors.statusLabelRedBg};
  color: ${(props) => props.theme.colors.primaryBlack70};
  font-size: 14px;
  line-height: 20px;
  padding: 12px 16px;
`;

const ErrorSummary = styled.div`
  color: ${(props) => props.theme.colors.statusLabelRedText};
`;
